const list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

export const checkMonth = function (value) {
  // 校验月份
  if (value.length > 1 && list.indexOf(value.slice(0, 2)) === -1) {
    return true;
  }
  return false;
};
